import React from 'react';
import PropTypes from 'prop-types';
import MUISlider from '@material-ui/core/Slider';
import { withStyles } from '@material-ui/core/styles';

const handleBoxShadow = '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)';

const PenlySlider = withStyles({
    root: {
        color: '#070606',
        height: 1,
        padding: '15px 0',
    },
    thumb: {
        height: 22,
        width: 22,
        backgroundColor: '#ef9761',
        boxShadow: handleBoxShadow,
        marginTop: -11,
        marginLeft: -8,
        '&:focus, &:hover': {
            boxShadow: '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)',
            '@media (hover: none)': {
                boxShadow: handleBoxShadow,
            },
        },
    },
    active: {},
    valueLabel: {
        left: 'calc(-50% + 9px)',
        top: -20,
        '& *': {
            background: 'transparent',
            color: '#000',
        },
        fontSize: 16,
        color: '#000',
        whiteSpace: 'nowrap',
    },
    mark: {
        opacity: 0,
    },
    markActive: {
        opacity: 0,
    },
})(MUISlider);

const Slider = ({ label, ...props }) => (
    <div className="slider">
        { label !== '' && <p>{ label }</p> }
        <PenlySlider valueLabelDisplay="on" { ...props } />
    </div>
);

Slider.propTypes = {
    label: PropTypes.string,
};

export default Slider;
